// PrivateRoutes.js
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../dashboard/Dashboard";
import DownloadReports from "../downloadReports/DownloadReports";
import BulkUpload from "../bulkUpload/BulkUpload";
import RoleMaster from "../roleMaster/RoleMaster";
import UserAccess from "../userAccess/UserAccess";
import ProtectedRoute from "./ProtectedRoute";

export const PrivateRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ProtectedRoute element={Dashboard} path="dashboard" />} />
      <Route path="/dashboard" element={<ProtectedRoute element={Dashboard} path="dashboard" />} />
      <Route path="/download-reports" element={<ProtectedRoute element={DownloadReports} path="download-reports" />} />
      <Route path="/upload" element={<ProtectedRoute element={BulkUpload} path="upload" />} />
      <Route path="/role-master" element={<ProtectedRoute element={RoleMaster} path="role-master" />} />
      <Route path="/user-access" element={<ProtectedRoute element={UserAccess} path="user-access" />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
